export default __webpack_public_path__ + "static/media/carousel-2.2b1ae7ee.png";